export default "__VITE_ASSET__DIre63Y$__"